import { Box, CircularProgress, Collapse, Divider } from '@mui/material';
import CategoryCarousel from '@src/components/Carousal/CategoryCarousal/CategoryCarousal';
import CustomButton from '@src/components/CustomButton/CustomButton';
import CustomDataGrid2 from '@src/components/CustomDataGrid/CustomDataGrid2';
import CustomModal from '@src/components/CustomModal';
import CustomTooltip from '@src/components/CustomTootip/CustomTooltip';
import { IsMobileWidth } from '@src/components/MediaQueryUtils';
import PageHeader from '@src/components/PageHeader/PageHeader';
import ProductDetails from '@src/components/ProductDetails/ProductDetails';
import SearchBar from '@src/components/SearchBar';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { debounce, getUniqueObjectsByKey, truncateField } from '@src/helpers/Helpers';
import { AxiosError, AxiosResponse } from 'axios';
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Category } from '../MarketPlace';
import PageHeaderMobile from '@src/components/PageHeader/PageHeaderMobile';
import CustomTextButton from '@src/components/CustomButton/CustomTextButton';
import ProductCustomCard from '@src/components/CustomCard/ProductCustomCard';
import DataNotFound from '@src/components/DataItemFound/DataNotFound';
import ProductCard from '@src/components/CustomCard/ProductCard';
import { Filters, TimeoutHandler } from '@src/interfaces/type';
import CustomFilter from '@src/components/CustomFilter/CustomFilter';
import ProductList from '@src/components/ProductListing/ProductList';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	padding: 20px;
	gap: 25px;
	overflow: scroll;
`;

const StyledDataGridHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	#firstRow {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		@media screen and (max-width: 750px) {
			gap: 15px;
			flex-direction: column;
		}
		#buttonContainer {
			display: flex;
			gap: 15px;
		}
	}
`;

const gridResponsiveStyles: any = {
	'@media (max-width: 478px)': {
		maxHeight: 'calc(100vh - 300px)',
		minHeight: 'calc(100vh - 300px)',
		paddingBottom: '25px',
	},
};

const productDetailsModalStyles = {
	backgroundColor: 'background.paper',
	borderRadius: '4px',
	boxShadow: '24px',
	maxWidth: '600px',
	maxHeight: '444px',
	'@media (max-width: 600px)': {
		width: '90%',
		maxWidth: '90%',
		maxHeight: '645px',
		height: '645px',
	},
};

const StyledMobileContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
	width: 100%;
	#filter-container {
		display: flex;
		gap: 10px;
		padding-left: 16px;
		padding-right: 16px;
		padding-bottom: 16px;
	}
`;

const SelectedItemsText = styled.div`
	color: #7d7d7d;
	font-size: 13px;
	font-weight: 600;
	margin-top: 4px;
`;

const ProductContainer = styled.div({
	background: '#F1F1F1',
	paddingTop: '2px',
	overflowY: 'auto',
	flexGrow: 1, // Ensure it takes up remaining space and allows scrolling
});

const StyledBottomBtnContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 72px;
	padding: 16px;
	background: var(--chat-header-bg);
	border: 1.5px solid var(--gray-color-light);
	z-index: 10;
	flex-shrink: 0; // Prevents resizing when the content overflows
`;

interface Props {
	products: any;
	setProducts: any;
	setAddProductsComponent: any;
	setOrderedFilteredProducts: any;
	setOrderedProducts: any;
	windowDimensions?: any;
	selectedIndex?: any;
	setSelectedIndex?: any;
	categories?: any;
	setCategories?: any;
	setSearching: any;
	setPage: any;
	totalPages: any;
	page: any;
	searchValue: any;
	setSearchValue: any;
	categoryOptions: any;
	setCategoryId: any;
	searching: any;
	loadingProducts: any;
	setLoadingProducts: any;
	totalCount: any;
	setTotalCount: any;
	increaseQuantity: any;
	decreaseQuantity: any;
	recommendedQuantity: any;
}

const OrderbookProducts: FC<Props> = ({
	products,
	setProducts,
	setAddProductsComponent,
	setOrderedFilteredProducts,
	setOrderedProducts,
	windowDimensions,
	selectedIndex,
	setSelectedIndex,
	categories,
	setCategories,
	setSearching,
	setPage,
	totalPages,
	page,
	searchValue,
	setSearchValue,
	categoryOptions,
	setCategoryId,
	searching,
	loadingProducts,
	setLoadingProducts,
	totalCount,
	setTotalCount,
	increaseQuantity,
	decreaseQuantity,
	recommendedQuantity,
}) => {
	const [selectedItemIds, setSelectedItemIds] = useState<string[]>([]);
	const [showDoneBtn, setShowDoneBtn] = useState(true);
	const [productDetailsModal, setProductDetailsModal] = useState(false);
	const [productDetailsData, setProductDetailsData] = useState([]);
	const [collapse, setCollapse] = useState(false);
	const [detailsMiodal, setDetailsModal] = useState(false);
	const [details, setDetails] = useState([]);
	const [filters, setFilters] = useState<Filters | null>(null);
	const [activeFilter, setActiveFilter] = useState('');

	const isMobileWidth = IsMobileWidth();

	const timeoutHandler = useRef<TimeoutHandler>(null);

	const columns = [
		// {
		// 	field: 'id',
		// 	headerName: 'Product ID',
		// 	width: 100,
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	renderCell: (params: any) => {
		// 		const productId = params.row.id;
		// 		return <div title={productId}>{truncateField(productId, 32)}</div>;
		// 	},
		// },
		{
			field: 'name',
			headerName: 'Part Name',
			width: 300,
			renderCell: (params: any) => {
				const name = params?.row?.name;
				return (
					<div
						style={{
							display: 'flex',
							gap: '8px',
							alignItems: 'center',
						}}
						title={name}
					>
						<img
							style={{ objectFit: 'contain' }}
							src={
								params?.row?.images?.[0]?.image ||
								params?.row?.images?.[0]?.url ||
								params?.row?.image ||
								'/placeholderImage.svg'
							}
							alt="product-img"
							width="24px"
							height="24px"
						/>
						{params?.row?.name?.length > 33 ? (
							<CustomTooltip title={params?.row?.name} placement="top">
								<p
									style={{
										maxWidth: '260px',
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
									}}
								>
									{params?.row?.name}
								</p>
							</CustomTooltip>
						) : (
							<p
								style={{
									maxWidth: '260px',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{params?.row?.name}
							</p>
						)}
					</div>
				);
			},
		},
		{ field: 'unit', headerName: 'Unit', width: 80 },
		{ field: 'price', headerName: 'Price (INR)', width: 100, align: 'center' },
		{
			field: 'category',
			headerName: 'Part Category',
			filterable: true,
			width: 160,
		},
	];

	const navigate = useNavigate();
	const { id, waId } = useParams();

	const handleArrowBack = () => {
		setAddProductsComponent(false);
	};

	const handleSearch = (value: any) => {
		setSearching(true);
		setSearchValue(value);
		setPage(1);
	};

	const handlePageChange = (event: any, value: number) => {
		if (page !== value) {
			setPage(value);
			setSelectedItemIds([]);
			setSearching(true);
			setLoadingProducts(true);
		}
	};

	const handleCategoryChange = (category: Category) => {
		if (selectedIndex !== category?.category_id) {
			setSelectedIndex(category?.category_id as number);

			if (category?.category_id !== 1000) {
				const items = products?.filter((item: any) => item?.categoryId === category?.category_id);
				setProducts(items);
			} else {
				setProducts(products);
			}
		}
	};

	const showDetails = (product: any) => {
		setDetails(product);
		setDetailsModal(true);
	};

	const onRowsSelectionHandler = (ids: any) => {
		setSelectedItemIds(ids);
	};

	const handleRowClick = (params: any, event: any) => {
		const data: any = products?.find((product: any) => product?.id === params?.id);
		const details: any = [
			{
				name: data?.name,
				image: data?.image || '/prodcut.png',
				images: params?.row?.images?.map((image: any) => {
					return { src: image?.image, alt: 'product-img' };
				}),
				description: data?.description,
				details: [
					`Part Category: ${data?.category}`,
					`Unit: ${data?.unit}`,
					`Price: ${data?.price}`,
				],
			},
		];
		setProductDetailsData(details);
		setProductDetailsModal(true);
	};

	const addNewProduct = () => {
		const selectedProducts = products
			?.filter((product: any) => selectedItemIds.includes(product?.id))
			?.map((item: any) => {
				return {
					...item,
					productId: item?.id,
					attributes: item?.unit,
					quantity: 0,
					recommend: item?.recommend,
					isSelection: false,
				};
			});

		const orderBook = products?.filter((product: any) => !selectedItemIds.includes(product?.id));
		setOrderedFilteredProducts((prevState: any) => {
			return [...selectedProducts, ...prevState];
		});
		setOrderedProducts((prevState: any) => {
			return [...selectedProducts, ...prevState];
		});
		setProducts(orderBook);
		setTotalCount((prevState: number) => prevState - selectedProducts?.length);

		setShowDoneBtn(true);
		setSelectedItemIds([]);
	};

	const handleSpecificProductSelect = (id: any) => {
		const ids: string[] = [];

		setProducts((prevState: any) => {
			return prevState?.map((item: any) => {
				if ((item?.id !== id && item?.isSelection) || (item?.id === id && !item?.isSelection)) {
					ids.push(item?.id);
				}
				if (item?.id === id) {
					return {
						...item,
						isSelection: !item?.isSelection,
					};
				}
				return item;
			});
		});
		setSelectedItemIds(ids);
	};

	const loadMore = debounce(() => {
		if (!loadingProducts) {
			// Prevent concurrent calls
			setLoadingProducts(true);
			//@ts-ignore
			setPage((prevState) => {
				return prevState + 1;
			});
		}
	}, 300);

	const handleSelectAll = (products: any) => {
		const ids: string[] =
			selectedItemIds?.length === products?.length ? [] : products?.map((item: any) => item?.id);

		setProducts((prevState: any) => {
			return prevState?.map((item: any) => {
				return {
					...item,
					isSelection: !(selectedItemIds?.length === products?.length),
				};
			});
		});

		setSelectedItemIds(ids);
	};

	const btnView = () => {
		return (
			<CustomButton
				title="Add To My Order"
				handleClick={addNewProduct}
				styles={{
					width: '320px',
					height: '40px',
					transition: 'background 0.3s ease, color 0.3s ease',
				}}
				disabled={!selectedItemIds?.length}
			/>
		);
	};

	useEffect(() => {
		return () => {
			setAddProductsComponent(false);
		};
	}, []);

	// if (isMobileWidth) {
	// 	return (
	// 		<StyledMobileContainer>
	// 			<PageHeaderMobile
	// 				title="Supplier’s Catalog"
	// 				setCollapse={setCollapse}
	// 				collapse={collapse}
	// 				onClick={() => {
	// 					setAddProductsComponent(false);
	// 				}}
	// 			/>
	// 			{collapse ? (
	// 				<Collapse
	// 					in={collapse}
	// 					style={{
	// 						display: 'flex',
	// 						gap: '15px',
	// 						alignItems: 'center',
	// 						flexShrink: 0,
	// 						padding: '16px',
	// 					}}
	// 				>
	// 					<SearchBar
	// 						style={{
	// 							width: '328px',
	// 							height: '36px',
	// 						}}
	// 						value={searchValue}
	// 						onChange={handleSearch}
	// 						isLoading={false}
	// 						autoFocus
	// 					/>
	// 				</Collapse>
	// 			) : null}
	// 			<CategoryCarousel
	// 				categories={categories}
	// 				handleCategoryChange={handleCategoryChange}
	// 				selectedIndex={selectedIndex}
	// 				setSelectedIndex={setSelectedIndex}
	// 				windowDimensions={windowDimensions}
	// 			/>
	// 			<div id="filter-container">
	// 				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
	// 					{products?.length ? (
	// 						<CustomTextButton
	// 							style={{
	// 								fontSize: '13px',
	// 								fontWeight: 700,
	// 								color: '#FF6120',
	// 								textDecoration: 'none',
	// 								maxWidth: '75px',
	// 								marginTop: '4px',
	// 							}}
	// 							title={
	// 								selectedItemIds?.length === products?.length
	// 									? 'Deselect All'
	// 									: 'Select All'
	// 							}
	// 							onClick={() => handleSelectAll(products)}
	// 						/>
	// 					) : null}
	// 					{selectedItemIds?.length && products?.length ? (
	// 						<SelectedItemsText>{selectedItemIds?.length} items selected </SelectedItemsText>
	// 					) : (
	// 						<SelectedItemsText>{products?.length} products found </SelectedItemsText>
	// 					)}
	// 				</div>
	// 			</div>
	// 			<Divider style={{ width: '100%' }} />
	// 			{products?.length ? (
	// 				<ProductContainer>
	// 					{products?.map((item: any) => (
	// 						<ProductCustomCard
	// 							key={item?.id}
	// 							//@ts-ignore
	// 							product={item}
	// 							increaseQuantity={() => {}}
	// 							decreaseQuantity={() => {}}
	// 							recommendedQuantity={() => {}}
	// 							isContainCheckbox
	// 							checkBoxSelection={handleSpecificProductSelect}
	// 							readOnlyCounter
	// 							hideBottom
	// 						/>
	// 					))}
	// 				</ProductContainer>
	// 			) : (
	// 				<div style={{ flexGrow: 1 }}>
	// 					<DataNotFound content="No Products Found" height="auto" />
	// 				</div>
	// 			)}
	// 			<StyledBottomBtnContainer>
	// 				<div style={{ display: 'flex', gap: '10px', padding: '10px', flexShrink: 0 }}>
	// 					{btnView()}
	// 				</div>
	// 			</StyledBottomBtnContainer>
	// 		</StyledMobileContainer>
	// 	);
	// }

	const modals = () => {
		if (detailsMiodal && details) {
			return (
				<CustomModal
					open={detailsMiodal}
					setOpen={setDetailsModal}
					header={false}
					style={productDetailsModalStyles}
				>
					{/* @ts-ignore */}
					<ProductDetails data={details} setOpenModal={setDetailsModal} />
				</CustomModal>
			);
		}
	};
	return (
		<div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
			<PageHeader title="Edit Order" activeIcon={true} handleArrowBack={handleArrowBack} />
			<Container>
				<StyledDataGridHeader>
					<div id="firstRow">
						<SearchBar
							style={{
								width: '328px',
								height: '36px',
							}}
							value={searchValue}
							onChange={handleSearch}
							isLoading={false}
						/>
						<div id="buttonContainer">
							{showDoneBtn ? (
								<CustomButton
									title="Done"
									color="secondary"
									handleClick={() => {
										handleArrowBack();
									}}
									styles={{
										width: '63px',
										height: '36px',
									}}
								/>
							) : null}
							<CustomButton
								title="Add To My Order"
								handleClick={addNewProduct}
								color="primary"
								styles={{
									width: '150px',
									height: '36px',
									padding: '7px 12px',
								}}
								disabled={!selectedItemIds?.length}
							/>
						</div>
					</div>
					<Box
						display="flex"
						justifyContent="flex-end"
						alignItems="center"
						sx={{
							px: 2,
							'@media (max-width: 550px)': {
								flexDirection: 'column',
								alignItems: 'flex-end',
								//minHeight: '75px',
							},
						}}
					>
						{selectedItemIds?.length ? <Box>{selectedItemIds?.length} items selected</Box> : null}
					</Box>
				</StyledDataGridHeader>

				<Box>
					<CustomFilter
						filters={filters}
						setFilters={setFilters}
						activeFilter={activeFilter}
						setActiveFilter={setActiveFilter}
						products={products}
						setFilteredProducts={setProducts}
					/>
					<Divider />
					{products?.length ? (
						//@ts-ignore
						<ProductList
							//@ts-ignore
							products={products}
							searching={searching}
							loadingProducts={loadingProducts}
							loadMore={loadMore}
							handleSpecificProductSelect={handleSpecificProductSelect}
							showDetails={showDetails}
							style={{ overflow: 'auto', height: 'calc(100vh - 150px)' }}
							totalCount={totalCount}
							increaseQuantity={increaseQuantity}
							decreaseQuantity={decreaseQuantity}
							recommendedQuantity={recommendedQuantity}
						/>
					) : (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: 'calc(100vh - 100px)',
							}}
						>
							No Products Found
						</div>
					)}
				</Box>
			</Container>
			{/* {productDetailsModal ? (
				<CustomModal
					open={productDetailsModal}
					setOpen={setProductDetailsModal}
					style={productDetailsModalStyles}
					title={'Product Details'}
					children={
						<ProductDetails setOpenModal={setProductDetailsModal} data={productDetailsData} />
					}
					header={false}
				/>
			) : null} */}
			{modals()}
		</div>
	);
};

export default OrderbookProducts;
